import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openDuplicatesRemoveGroupModal = (groupId: string) =>
    openPopupHelper({ popupName: popupNames.DUPLICATES_REMOVE_GROUP_MODAL, onClose: closeDuplicatesRemoveGroupModal, data: { groupId } });

const closeDuplicatesRemoveGroupModal = () => closePopupHelper(popupNames.DUPLICATES_REMOVE_GROUP_MODAL);
